import React, { useMemo } from 'react';
import gql from 'graphql-tag';
import propTypes from 'prop-types';
import { useQuery } from 'react-apollo';
import { FaArrowLeft } from 'react-icons/fa';
import useMe from '../../../hooks/useMe';
import useContext from '../../../hooks/useContext';

import useReports from '../../../hooks/useReports';

import SubjectCard from '../../../components/SubjectCard';

const commentsAssemblySubjectDetailedFragment = gql`
  fragment commentsAssemblySubjectDetailedFragment on CommentDetail {
    user {
      _id
      name
      email
      condominiums {
        data
      }
    }
    text
    createdAt
  }
`;

const votesUserSubjectFragment = gql`
  fragment votesUserSubjectFragment on AssemblyUser {
    name
    condominiums {
      data
    }
  }
`;

const optionVotesDescriptionSubjectDetailFragment = gql`
  fragment optionVotesDescriptionSubjectDetailFragment on OptionDetail {
    description
    votes {
      ...votesUserSubjectFragment
    }
  }
  ${votesUserSubjectFragment}
`;

const getGql = gql`
  query assembly($_id: ID!, $detailed: Boolean, $withCondominium: Boolean) {
    assembly(_id: $_id, detailed: $detailed, withCondominium: $withCondominium) {
      _id
      description
      condominium
      type
      status
      subjects {
        _id
        title
        description
        options {
          ...optionVotesDescriptionSubjectDetailFragment
        }
        comments {
          ...commentsAssemblySubjectDetailedFragment
        }
      }
      openingDate
      endDate
    }
  }
  ${commentsAssemblySubjectDetailedFragment}
  ${optionVotesDescriptionSubjectDetailFragment}
`;

export default function SubjectDetail({ match, history }) {
  const [me] = useMe();
  const { condominiumId } = useContext();
  const { commentsReport, votesReport } = useReports();

  const { data, loading } = useQuery(getGql, {
    skip: !condominiumId || !me,
    variables: {
      _id: match.params.assemblyId,
      detailed: true,
      withCondominium: true,
    },
  });

  const assembly = useMemo(() => {
    if (!data) return {};
    return data.assembly;
  }, [data]);

  return (
    <div className="dashboard h-100 d-flex flex-column">
      {loading ? (
        <div className="justify-content-center d-flex p-3">
          <h4>Carregando</h4>
        </div>
      ) : (
        <>
          <FaArrowLeft onClick={() => history.push('/dashboard')} className="mt-3 back-icon" />

          <p>{assembly.description}</p>
          {assembly &&
            assembly.subjects &&
            assembly.subjects.map(subject => (
              <div className="mt-3" key={subject._id}>
                <SubjectCard assembly={assembly} subject={subject} detailed />
              </div>
            ))}
          <>
            <button
              type="button"
              className="btn btn-outline-secondary btn-block mb-1"
              onClick={() => votesReport(assembly._id)}
            >
              Gerar relatório de votação
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary btn-block mb-5"
              onClick={() => commentsReport(assembly._id)}
            >
              Gerar relatório de comentários
            </button>
          </>
        </>
      )}
    </div>
  );
}

SubjectDetail.propTypes = {
  match: propTypes.object.isRequired,
  history: propTypes.object.isRequired,
};
